import { queryOptions } from '@tanstack/react-query';

import { fetchBackend } from './apiClient';
import type { AwsCredentialsForList } from './integrations/cloud/aws/credentials';
import type { AwsRole } from './integrations/cloud/aws/roles';
import type { DatadogApiCredentialsForList } from './integrations/monitoring/datadog';
import type { GithubConfigForList } from './integrations/scm/github';
import type { S3Bucket } from './integrations/terraformBackend/buckets';
import type { HCPCloudTokenForList } from './integrations/terraformBackend/hcpCloud';
import type { ProjectMember } from './project';

export type ProjectIntegrations = {
  projectName: string;
  id: string;
  neo4jDatabaseName: string;
  members: ProjectMember[];
  createdAt: string;
  updatedAt: string;
  awsCredentials: AwsCredentialsForList[];
  awsRoles: AwsRole[];
  hcpCloudTokens: HCPCloudTokenForList[];
  datadogApiCredentials: DatadogApiCredentialsForList[];
  githubInstallations: GithubConfigForList[];
  s3_buckets: S3Bucket[];
};

export const adminQueries = {
  all: () => ['admin'],
  integrations: () =>
    queryOptions({
      queryKey: [...adminQueries.all(), 'integrations'],
      queryFn: async () => {
        const adminIntegrationsList = await fetchBackend(
          `/internal/admin/integrations`,
          {
            method: 'GET',
          },
        );

        if (!adminIntegrationsList.ok) {
          throw new Error(`Error: ${adminIntegrationsList.statusText}`);
        }

        return (await adminIntegrationsList.json()) as Record<
          string,
          ProjectIntegrations
        >;
      },
    }),
} as const;
